module.exports = __webpack_public_path__ + "img/logo-grey.7fb2cb94.svg";